import React, {useEffect, useState} from 'react';
import './Styles/itemsTable.css';
import './Styles/glow.css';
import {LoadingImage} from "./App";
import "./Styles/card.css"
import {supabase} from "./supabaseClient";
const TextTruncate = require('react-text-truncate'); // CommonJS or UMD

interface WishlistItem { index: number, name: string, price: string, image: string, link: string }

function ItemsLoader() {
    const [downloaded, setDownloaded] = useState(false);
    const [items, setItems] = useState<WishlistItem[]>([]);

    useEffect(() => {
        supabase
            .from('wishlist_items')
            .select('sort_order, name, price, image, link')
            .order('sort_order', {ascending: true})
            .then(({data, error}) => {
                if (error) {
                    console.log(error);
                    setDownloaded(true);
                    return;
                }
                setItems((data || []).map(row => ({
                    index: row.sort_order,
                    name: row.name,
                    price: row.price,
                    image: row.image,
                    link: row.link,
                })));
                setDownloaded(true);
            });
    }, []);

    if (!downloaded) {
        return LoadingImage();
    }

    if (items.length === 0) {
        return <p className="WishEmpty">Список пуст</p>;
    }

    return (
        <div className="WishGrid">
            {items.map((item) => <WishCard key={item.index} item={item}/>)}
        </div>
    );
}

function WishCard({item}: { item: WishlistItem }) {

    const showRuble = item.price !== "" && !item.price.includes("₸");

    return (
        <div className="WishCard">
            <div className="WishCard-media">
                <img className="WishCard-image" src={item.image} alt={item.name} width="150"/>
            </div>
            <div className="WishCard-body">
                <div className="WishCard-name">
                    <TextTruncate line={3} text={item.name} element="span"/>
                </div>
                {item.price !== "" && <p className="WishCard-price">{item.price} {showRuble && "₽"}</p>}
                {item.link !== "" && (
                    <div className="WishCard-actions">
                        <MyButton label="Купить" myValue={() => {
                            window.location.href = item.link;
                        }}/>
                    </div>
                )}
            </div>
        </div>
    );
}

interface MyButtonParams {
    label: string
    myValue: () => void;
}

export function MyButton(fn: MyButtonParams) {

    return (
        <button
            className="Glow"
            type="button"
            onClick={(e) => {
                fn.myValue();
            }}
        >{fn.label}</button>
    );
}


export default ItemsLoader;
